import { createQueryKeys } from '@lukemorales/query-key-factory';

export const freeTier = createQueryKeys('freeTier', {
  remaining: null,
  onboarding: null,
});
